import React from 'react';

const Hero = () => (
  <section id="home" className="hero" style={{ padding: '2rem 1rem', background: 'linear-gradient(135deg, #f093fb 0%, #f5576c 100%)' }}>
    <h1 style={{ fontSize: '2rem', marginBottom: '0.5rem', color: 'white' }}>Tech Wala Online Academy</h1>
    <p style={{ fontSize: '1rem', marginBottom: '1rem', color: 'white' }}>Learn by Doing | 11 Free Pro Tools</p>
  </section>
);

export default Hero;
